import React, { useEffect, useRef, useState } from "react";
import { Spin } from "antd";
import "./MetabaseAppEmbed.less";

// Интерфейс для пропсов компонента
interface ComponentProps {
  isLoading?: boolean; // Флаг загрузки
  reportUrl?: string; // URL отчета для встраивания
  className?: string; // Дополнительные CSS классы
  onMessage?: (event: MessageEvent) => void; // Обработчик сообщений от iframe
  onLocationChange?: (location: string) => void; // Обработчик изменения URL в iframe
}

/* ------------------------------------------------------ Начало компонента ------------------------------------------------------ */

export const MetabaseAppEmbed = (props: ComponentProps) => {
  const { isLoading, reportUrl, className, onMessage, onLocationChange } = props;

  // Ref для доступа к iframe
  const iframeRef = useRef<HTMLIFrameElement>(null);
  // Состояние для отслеживания загрузки iframe
  const [iframeLoading, setIframeLoading] = useState(true);

  // Обработчик сообщений от iframe
  const messageHandler = (event: MessageEvent) => {
    // Проверяем, что сообщение от нашего iframe
    if (event.source === iframeRef.current?.contentWindow) {
      // Если передан обработчик сообщений, вызываем его
      if (onMessage) {
        onMessage(event);
      }

      // Если передан обработчик изменения URL и сообщение содержит новый URL
      if (onLocationChange && event.data?.location) {
        onLocationChange(event.data.location);
      }
    }
  };

  // Эффект для установки обработчика сообщений
  useEffect(() => {
    window.addEventListener("message", messageHandler);
    // Очистка обработчика при размонтировании компонента
    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, [onMessage, onLocationChange]);

  // Эффект для сброса состояния загрузки при изменении URL отчета
  useEffect(() => {
    setIframeLoading(true);
  }, [reportUrl]);

  return (
    <div className={`metabase-app-embed ${className || ""}`}>
      {/* Показываем спиннер, если идет загрузка отчета или iframe */}
      {reportUrl && (isLoading || iframeLoading) && (
        <div className="metabase-app-embed__loader">
          <Spin />
        </div>
      )}

      {/* Отображаем iframe только если есть URL отчета */}
      {reportUrl && (
        <iframe
          ref={iframeRef}
          className="metabase-app-embed__frame"
          src={reportUrl}
          frameBorder="0"
          allowTransparency
          onLoad={() => setIframeLoading(false)} // Обработчик завершения загрузки iframe
        />
      )}
    </div>
  );
};
